import React from 'react';
import { PropTypes } from 'prop-types';
import Image from 'next/image';
import { IC_TIMER_RED } from '@common/Assets/images';
import { useTranslation } from '@common/i18n';

const OfferTimeCounter = (props) => {
  const [timer, setTimer] = React.useState('');
  const Ref = React.useRef(null);
  const t = useTranslation();

  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());

    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    let hours = Math.floor((total / 1000 / 60 / 60) % 24);
    let days = Math.floor((total / 1000 / 60 / 60 / 24) % 24);
    if (days > 0 && days < 2) {
      hours = hours + 24;
      days = days - 1;
    }
    return {
      days,
      total,
      hours,
      minutes,
      seconds,
    };
  };

  const startTimer = (e) => {
    const { total, hours, minutes, seconds } = getTimeRemaining(e);
    if (total >= 0) {
      // update the timer
      // check if less than 10 then we need to
      // add '0' at the beginning of the variable
      setTimer(
        (hours > 9 ? hours : '0' + hours) +
          'H : ' +
          (minutes > 9 ? minutes : '0' + minutes) +
          'M : ' +
          (seconds > 9 ? seconds : '0' + seconds) +
          'S',
      );
    }
  };

  const clearTimer = (e) => {
    // If you adjust it you should also need to
    // adjust the Endtime formula we are about
    // to code next
    setTimer('');

    // If you try to remove this line the
    // updating of timer Variable will be
    // after 1000ms or 1sec
    if (Ref.current) clearInterval(Ref.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    Ref.current = id;
  };

  const getDeadTime = (time) => {
    const deadline = new Date(time);

    // This is where you need to adjust if
    // you entend to add more time
    deadline.setSeconds(deadline.getSeconds());
    return deadline;
  };

  // We can use useEffect so that when the component
  // mount the timer will start as soon as possible

  // We put empty array to act as componentDid
  // mount only
  React.useEffect(() => {
    const myToday = new Date(props?.time.getFullYear(), props?.time.getMonth(), props?.time.getDate(), 23, 23, 59);
    const { days } = getTimeRemaining(myToday);
    if (days <= 1) {
      clearTimer(getDeadTime(myToday));
    } else if (days >= 2 && days <= 7) {
      if (Ref.current) clearInterval(Ref.current);
      setTimer(`${days} ${days === 1 ? 'Day' : 'Days'}`);
    }
  }, []);

  // Another way to call the clearTimer() to start
  // the countdown is via action event from the
  // button first we create function to be called
  // by the button
  // const onClickReset = () => {
  //   clearTimer(getDeadTime());
  // };

  if (timer !== '') {
    if (props?.pageType === 'PDP') {
      return (
        <div className="discountEnds">
          <Image className="ic" src={IC_TIMER_RED.src} width="16px" height="16px" alt="" />
          <div className="discLabel">{t('ProductDetail.discountEndsIn')}</div>
          <div className="timer">{timer}</div>
        </div>
      );
    } else {
      return (
        <div className="discountEnds">
          <Image className="ic" src={IC_TIMER_RED.src} width="9px" height="10px" alt="" />
          <div className="timer">{timer}</div>
        </div>
      );
    }
  } else {
    return '';
  }
};

OfferTimeCounter.propTypes = {
  time: PropTypes.any,
  sku: PropTypes.any,
  pageType: PropTypes.string,
};

export default OfferTimeCounter;
